const primaryButtonProps = {
  color: 'secondary',
  class: 'primary--text px-8',
  elevation: 8,
};

export default primaryButtonProps;
